//theme
import { theme as footlockerTheme } from 'shared/styles/theme/footlockerTheme';

export const buildConfig = {
  LOGO: {
    MWEB: {
      HEIGHT: 17,
      WIDTH: 82,
      URL: 'https://preprod-asset-footlocker.nykaafashion.com/footlocker-images/flLogo.svg',
    },
    DWEB: {
      HEIGHT: 28,
      WIDTH: 119,
      URL: 'https://preprod-asset-footlocker.nykaafashion.com/footlocker-images/flLogo.svg',
    },
    FOOTER: {
      HEIGHT: 24,
      WIDTH: 108,
      URL: 'https://preprod-asset-footlocker.nykaafashion.com/footlocker-images/flLogo.svg',
    },
    COUPONS: {
      HEIGHT: 11,
      WIDTH: 54,
      URL: 'https://preprod-asset-footlocker.nykaafashion.com/footlocker-images/flLogo.svg',
    },
  },
  FAVICON: 'https://preprod-asset-footlocker.nykaafashion.com/footlocker-images/32fevicon.ico',
  PWA_ICONS: {
    ICON_512: 'https://preprod-asset-footlocker.nykaafashion.com/footlocker-images/512.svg',
    ICON_192: 'https://preprod-asset-footlocker.nykaafashion.com/footlocker-images/192.svg',
    ICON_144: 'https://preprod-asset-footlocker.nykaafashion.com/footlocker-images/144.svg',
    ICON_32: 'https://preprod-asset-footlocker.nykaafashion.com/footlocker-images/32.svg',
    ICON_16: 'https://preprod-asset-footlocker.nykaafashion.com/footlocker-images/16.svg',
  },
  THEME: footlockerTheme,
};
